/**
 * PortalSnowEffect.jsx
 * Animated snowfall effect for Customer Portal
 * Renders BEHIND all content (z-index: 0)
 */
import React, { useEffect, useState } from 'react';

const PortalSnowEffect = ({ intensity = 'medium', speed = 'medium', enabled = true }) => {
  const [snowflakes, setSnowflakes] = useState([]);

  // Intensity settings (number of snowflakes)
  const intensityConfig = {
    light: 25,
    medium: 50,
    heavy: 80
  };

  // Speed settings (animation duration multiplier - higher = slower)
  const speedConfig = {
    slow: 2.5,
    medium: 1.5,
    fast: 0.8
  };

  const flakeCount = intensityConfig[intensity] || intensityConfig.medium;
  const speedMultiplier = speedConfig[speed] || speedConfig.medium;

  useEffect(() => {
    if (!enabled) {
      setSnowflakes([]);
      return;
    }

    // Generate snowflakes with varied properties
    const flakes = Array.from({ length: flakeCount }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      animationDuration: (Math.random() * 8 + 8) * speedMultiplier,
      animationDelay: Math.random() * 5,
      size: Math.random() * 3 + 1.5, // 1.5-4.5px
      opacity: Math.random() * 0.4 + 0.3, // 0.3-0.7 (subtle)
    }));

    setSnowflakes(flakes);
  }, [enabled, intensity, speed, flakeCount, speedMultiplier]);

  if (!enabled) return null;

  return (
    <>
      <style>{`
        @keyframes portal-snowfall {
          0% {
            transform: translateY(-10px) translateX(0);
            opacity: 0;
          }
          5% {
            opacity: 1;
          }
          95% {
            opacity: 0.8;
          }
          100% {
            transform: translateY(100vh) translateX(20px);
            opacity: 0;
          }
        }
        
        .portal-snowflake {
          position: fixed;
          top: -10px;
          background: white;
          border-radius: 50%;
          animation: portal-snowfall linear infinite;
          box-shadow: 0 0 3px rgba(255,255,255,0.6);
          pointer-events: none;
          z-index: 1;
        }
      `}</style>
      
      {snowflakes.map(flake => (
        <div
          key={flake.id}
          className="portal-snowflake"
          style={{
            left: `${flake.left}%`,
            width: `${flake.size}px`,
            height: `${flake.size}px`,
            opacity: flake.opacity,
            animationDuration: `${flake.animationDuration}s`,
            animationDelay: `${flake.animationDelay}s`
          }}
        />
      ))}
    </>
  );
};

export default PortalSnowEffect;
